var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.5 1"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-plus"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 526",
    d: "M0 .5h11.5",
    fill: "none",
    stroke: "#333",
    strokeLinejoin: "round"
  }))));
}

export default __webpack_public_path__ + "a3743e942c623a42b652323769acefa3.svg";
export { SvgMinus as ReactComponent };